import React, { useEffect, useState } from 'react';
import { OrganicMartesHero } from '../components/OrganicMartesHero';
import { Benefits } from '../components/Benefits';
import { Results } from '../components/Results';
import { OrganicMartesCTASection } from '../components/OrganicMartesCTASection';
import { AuthorBio } from '../components/AuthorBio';
import { Footer } from '../components/Footer';
import { FacebookPixel } from '../components/FacebookPixel';
import { ThankYouPage } from '../components/ThankYouPage';
import { NotificationToast } from '../components/NotificationToast';
import { trackEvent } from '../utils/analytics';
export function OrganicMartesPage() {
  const [showThankYou, setShowThankYou] = useState(false);
  // Track page visit on mount
  useEffect(() => {
    trackEvent('page_visit');
  }, []);
  if (showThankYou) {
    return <ThankYouPage data-id="element-1369" />;
  }
  return <div className="flex flex-col min-h-screen w-full bg-gradient-to-b from-gray-900 to-black text-white" data-id="element-1370">
      <FacebookPixel pixelId="754551913878347" data-id="element-1371" />
      <NotificationToast data-id="element-1372" />
      <header className="fixed top-0 left-0 right-0 z-40 w-full px-4 py-2 bg-gray-900 bg-opacity-80 backdrop-blur-lg border-b border-gray-800 h-[88px]" data-id="element-1373">
        <div className="flex flex-col items-center justify-center h-full gap-0.5" data-id="element-1374">
          <div className="w-full max-w-[600px] h-[40px] flex items-center justify-center px-4" data-id="element-1375">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gqSiWiuARq6wcs7g3ZrS3R/TRUSTED_BADGE.png" alt="Trusted by 1000+ Verified Customers" className="w-full h-auto max-h-[40px] object-contain" data-id="element-1376" />
          </div>
          <div className="w-[100px] h-[28px] flex items-center justify-center" data-id="element-1377">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9nsoAdMCr2MakXFCqq5bSP/gb_signature.png" alt="Signature" className="w-full h-auto max-w-[100px]" width="100" height="28" data-id="element-1378" />
          </div>
        </div>
      </header>
      <main className="flex-grow w-full pt-[88px]" data-id="element-1379">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-5xl" data-id="element-1380">
          <div className="py-8 md:py-16 space-y-16 md:space-y-24" data-id="element-1381">
            <OrganicMartesHero isPaused={false} setShowThankYou={setShowThankYou} data-id="element-1382" />
            <Benefits data-id="element-1383" />
            <Results data-id="element-1384" />
            <OrganicMartesCTASection setShowThankYou={setShowThankYou} data-id="element-1385" />
            <AuthorBio data-id="element-1386" />
          </div>
        </div>
      </main>
      <Footer data-id="element-1387" />
    </div>;
}